<template>
  <v-container fluid class="px-0">
    <div class="customer-page">
      <v-row>
        <v-col cols="12" md="12">
          <v-card class="user-card ma-1" min-height="282">
            <v-card-text class="pa-5 pt-9 fill-height">
              <v-row no-gutters class="fill-height">
                <v-col
                  cols="12"
                  md="2"
                  class="d-flex justify-center align-center flex-column"
                >
                  <div class="avatar-wrapper">
                    <v-img
                      class="user-avatar"
                      contain
                      v-bind:src="initvalue.customerimage"
                    ></v-img>
                  </div>
                  <v-chip small class="mr-2 mt-4 mb-4 mb-sm-0" color="primary">
                    {{ initvalue.customerstatus }}</v-chip
                  >
                </v-col>
                <v-col>
                  <v-row>
                    <p class="user-name greyMedium--text font-weight-regular">
                      {{ initvalue.customername }}
                    </p>
                    <v-spacer></v-spacer>
                    <v-btn @click="$router.replace({ name: 'CustomerList' })" color="primary" text>
                      <v-icon class="mr-2">mdi-check</v-icon>
                      Done
                    </v-btn>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="5"
                      class="
                        pl-0 pl-sm-4
                        d-flex
                        flex-column
                        align-center align-sm-start
                      "
                    >
                      <p class="user-work ma-0"><b>CUSTOMER</b></p>
                      <p class="two-line">{{ initvalue.customername }}</p>
                      <p class="two-line">{{ initvalue.customeraddress }}</p>
                      <p class="two-line">{{ initvalue.customerphone }}</p>
                      <p class="two-line">{{ initvalue.customermobile }}</p>
                    </v-col>
                    <v-col
                      cols="12"
                      md="4"
                      class="
                        pl-0 pl-sm-4
                        d-flex
                        flex-column
                        align-center align-sm-start
                      "
                    >
                    <div style="margin-bottom: 5px">
                      <p class="user-work ma-0"><b>LOCATION</b></p>
                      <p class="two-line">{{ this.townships.find(township=>township._id==initvalue.townshipid)!=null ? this.townships.find(township=>township._id==initvalue.townshipid).townshipname : '' }}, {{ this.regions.find(region=>region._id==initvalue.regionid)!=null ? this.regions.find(region=>region._id==initvalue.regionid).regionname : '' }}</p>
                      <p style="margin-bottom: 5px"></p>
                    </div>
                    <div style="margin-bottom: 5px">
                      <p class="user-work ma-0"><b>CUSTOMER TYPE</b></p>
                      <p class="two-line">{{ initvalue.customertype }}</p>                
                    </div>
                    </v-col>
                    <v-col
                      cols="12"
                      md="3"
                      class="
                        pl-0 pl-sm-4
                        d-flex
                        flex-column
                        align-center align-sm-start
                      "
                    >
                      <div style="margin-bottom: 5px">
                      <p class="user-work ma-0"><b>CONTACT PERSON</b></p>
                      <p class="two-line">{{ initvalue.customercontact }}</p>
                      <p class="two-line">{{ initvalue.customerpayterms }}</p>
                      </div>
                      <div style="margin-bottom: 5px">
                      <p class="user-work ma-0"><b>NOTE</b></p>
                      <p class="two-line">{{ initvalue.customernote }}</p>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12" cols="12" class="pt-0 pt-sm-3">
          <v-row>
            <v-col cols="12">
              <v-card class="folder-card ma-1" min-height="282">
                <v-card-text class="pa-5 pt-0">

                  <v-tabs color="secondary">
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab
                      ref="filesTab"
                      class="text-capitalize font-weight-regular"
                      :key="2"
                      :href="'#tab-profiles'"
                    >
                      Profiles
                    </v-tab>
                    <v-tab
                      class="text-capitalize font-weight-regular"
                      :key="3"
                      :href="'#tab-images'"
                    >
                      Images
                    </v-tab>

                    <v-tab-item
                      :key="2"
                      :value="'tab-profiles'"
                      class="pb-0 pb-sm-3 pb-lg-0"
                    >
                      <v-divider></v-divider>
                      <v-row
                        justify-xl="space-around"
                        justify="start"
                        class="d-flex flex-nowrap overflow-x-auto pa-4 pt-5"
                      >
                        <v-col cols="12" md="12" sm="12">
                          <v-data-table
                            :headers="profileHeaders"
                            :items="customerprofiles"
                            :items-per-page="100"
                            class="elevation-0"
                          >
                            <template v-slot:item.userid="{ item }">
                              <v-avatar v-if="item.userid" size="35">
                                <img v-bind:src="users.find(user=>user._id==item.userid).userimage" alt="">
                              </v-avatar>
                              <v-avatar
                                v-else
                                color="warning"
                                size="35">
                                <span class="white--text headline">{{ item.username[0].toUpperCase() }}</span>
                              </v-avatar>
                            </template>
                            <template v-slot:item.createdAt="{ item }">
                              {{
                                new Date(item.createdAt).toLocaleString(
                                  "en-SG",
                                  {
                                    year: "numeric",
                                    month: "numeric",
                                    day: "numeric",
                                  }
                                )
                              }}
                            </template>
                            <template v-slot:item.actions="{ item }">
                              <v-btn
                                icon
                                color="primary"
                                @click="viewProfile(item)"
                              >
                                <v-icon>mdi-text-box-search</v-icon>
                              </v-btn>
                            </template>
                          </v-data-table>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                  </v-tabs>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row> </v-row>
        </v-col>
      </v-row>
    </div>
    <div>
      <v-dialog
      v-model="showViewProfile"
      max-width="1000px"
      >
      <v-card>
        <v-card-title>
          <span class="text-h5">View Profile</span>
        </v-card-title>
          <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="12">
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">
                        </th>
                        <th class="text-left">
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td><b>Purchase amount</b></td>
                        <td>{{ profile['purchaseAmount'] }}</td>
                      </tr>
                      <tr>
                        <td><b>Ordering frequency</b></td>
                        <td>{{ profile['orderingFrequency'] }}</td>
                      </tr>
                      <tr>
                        <td><b>Our items sold by customer</b></td>
                        <td>{{ getItems(profile['ownItems']) }}</td>
                      </tr>
                      <tr>
                        <td><b>Our brands sold by customer</b></td>
                        <td>{{ getBrands(profile['ownBrands']) }}</td>
                      </tr>
                      <tr>
                        <td><b>Other brands sold by customer</b></td>
                        <td>{{ getBrands(profile['otherBrands']) }}</td>
                      </tr>
                      <tr>
                        <td><b>Product groups sold by customer</b></td>
                        <td>{{ getGroups(profile['groups']) }}</td>
                      </tr>
                      <tr>
                        <td><b>Product categories sold by customer</b></td>
                        <td>{{ getCategories(profile['categories']) }}</td>
                      </tr>
                      <tr>
                        <td><b>Our POSM at this location</b></td>
                        <td>{{ profile['haveOwnPosm'].join(", ") }}</td>
                      </tr>
                      <tr>
                        <td><b>Other POSM at this location</b></td>
                        <td>{{ profile['haveOtherPosm'].join(", ") }}</td>
                      </tr>
                      <tr>
                        <td><b>POSM requested by customer</b></td>
                        <td>{{ profile['requestedPosm'].join(", ") }}</td>
                      </tr>
                      <tr>
                        <td><b>Preferred promotion schemes</b></td>
                        <td>{{ profile['promotionSchemes'].join(", ") }}</td>
                      </tr>
                      <tr>
                        <td><b>Notes</b></td>
                        <td>{{ profile['profilenote'] }}</td>
                      </tr>
                      <tr></tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col cols="12">
            </v-col>
            </v-row>
            
          </v-container>
          
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="showViewProfile = false"
            >
              Close
            </v-btn>
          </v-card-actions>
      </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "Profile",

  data() {
    return {
      initvalue: {},
      transactions: [],
      customerprofiles: [],
      showViewProfile: false,
      profile: {},
      profileHeaders: [
        { text: "Purchase", value: "purchaseAmount" },
        { text: "Frequency", value: "orderingFrequency" },
        { text: "User", value: "userid" },
        { text: "Created", value: "createdAt" },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },
  computed: {
    ...mapState('Brand', ['brands']),
    ...mapState('Item', ['items']),
    ...mapState('ItemCategory', ['itemcategories']),
    ...mapState('ItemGroup', ['itemgroups']),
    ...mapState('Region', ['regions']),
    ...mapState('Township', ['townships']),
    ...mapState('User', ['users']),
  },
  methods: {
    ...mapActions('Brand', ["getBrandsRequest"]),
    ...mapActions('Item', ["getItemsRequest"]),
    ...mapActions('ItemCategory', ["getItemCategoriesRequest"]),
    ...mapActions('ItemGroup', ["getItemGroupsRequest"]),
    ...mapActions('Region', ["getRegionsRequest"]),
    ...mapActions('Township', ["getTownshipsRequest"]),
    ...mapActions('User', ["getUsersRequest"]),
    viewProfile(item) {
      this.profile = item;
      this.showViewProfile = true;
    },
    getBrands(list){
      let results = list.map(obj=> this.brands.find(brand=>brand._id==obj).brandname);
      return results.join(", ");
    },
    getItems(lists){
      let results = lists.map(obj=> this.items.find(item=>item._id==obj).itemname);
      return results.join(", ");
    },
    getCategories(lists){
      console.log("Categories", lists);
      let results = lists.map(obj=> this.itemcategories.find(category=>category._id==obj)!=null ? this.itemcategories.find(category=>category._id==obj).itemcategoryname : '');
      console.log("Categories", results);
      return results.join(", ");
    },
    getGroups(lists){
      console.log("Groups", lists);
      let results = lists.map(obj=> this.itemgroups.find(group=>group._id==obj)!=null ? this.itemgroups.find(group=>group._id==obj).itemgroupname : '');
      console.log("Groups", results);
      return results.join(", ");
    }
  },
  async created() {
    this.initvalue = this.$route.params;
    if (!this.initvalue._id) this.$router.push({ name: "CustomerList" });
    console.log("HERE", this.initvalue._id);
    if(this.brands.length==0) this.getBrandsRequest();
    if(this.items.length==0) this.getItemsRequest();
    if(this.itemcategories.length==0) this.getItemCategoriesRequest();
    if(this.itemgroups.length==0) this.getItemGroupsRequest();
    if(this.regions.length==0) this.getRegionsRequest();
    if(this.townships.length==0) this.getTownshipsRequest();
    if(this.users.length==0) this.getUsersRequest();
  },
};
</script>

<style src="./View.scss" lang="scss"/>
